// The Entra ID directory resource is identified by its Azure Resource Manager id,
// `/tenants/{tenantId}`, so it never shares a provider resource id with the tenant's
// Microsoft 365 workspace. Operators know the directory by the bare tenant id, so
// anything that labels the resource shows that instead of the ARM path.
const ARM_TENANT_PREFIX = '/tenants/';

export const entraTenantIdFromProviderId = (providerId: string): string =>
  providerId.startsWith(ARM_TENANT_PREFIX)
    ? providerId.slice(ARM_TENANT_PREFIX.length)
    : providerId;
